<script>
  export let scoped = {};
  scoped;
</script>

<slot/>
